import {Nullable, VariantAttributeType} from "../../definitions/types";
import {VariantAttributeModel} from "../domain/variantAttributeModel";

export class VariantAttributesModel {
    private readonly _variantAttributes: VariantAttributeModel[];

    constructor(variantAttributeTypes: Nullable<VariantAttributeType>[]) {
        this._variantAttributes = variantAttributeTypes
            .filter((variantAttribute): variantAttribute is VariantAttributeType => variantAttribute !== null)
            .map((variantAttribute) => new VariantAttributeModel(variantAttribute));
    }

    /**
     * @property models
     * @description The variant attributes of the variant product
     * @returns {VariantAttributeModel[]}
     */
    public get models(): VariantAttributeModel[] {
        return this._variantAttributes;
    }

    /**
     * @method count
     * @description Returns the number of variant attributes for the variant product
     * @returns {number}
     */
    public get count(): number {
        return this._variantAttributes.length;
    }

    /**
     * @method any
     * @description Returns true if the variant product has variant attributes
     * @returns {boolean}
     */
    public get any(): boolean {
        return this.count > 0;
    }

    /**
     * @method concatenate
     * @description Returns a string representation of the variant attributes of the variant product if it has variant attributes otherwise undefined
     * @returns {string | undefined}
     * @example 'Screen Size: 55" | Color: Black | Memory: 64GB'
     */
    public get concatenate(): string | undefined {
        return this.any
            ? this._variantAttributes.map((variantAttribute) => variantAttribute.toString).join(" | ")
            : undefined;
    }
}